import * as React from 'react';

import { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

import { ORGANIZATION_COMPANY_REVENUE_TIME_SETTINGS } from 'af-constants/reduxForms';

import Description from './Description';
import EmailList from './EmailList';
import NotificationTimeSettings from './NotificationTimeSettings';

const notificationType = OrganizationNotificationType.COMPANIES_REVENUE;

const NotificationSettingsForms: React.FC = () => {

	return (
		<div className="form-box">
			<Description />
			<NotificationTimeSettings formType={ORGANIZATION_COMPANY_REVENUE_TIME_SETTINGS} notificationType={notificationType}/>
			<EmailList notificationType={notificationType}/>
		</div>
	);
};

export default React.memo(NotificationSettingsForms);
